import { isEmail, isURL, isLength } from 'validator';

// Validation helper
const createValidation = (validator, errorMessage) => (
  (...args) => validator(...args) || errorMessage
);

// Validator wrappers
export const typeEmail = createValidation(
  (str = '') => isEmail(str),
  'Por favor, digite um email válido',
);

export const typeUrl = createValidation(
  (str = '') => isURL(str),
  'Por favor, digite uma URL válida',
);

// Custom rules
export const requiredField = createValidation(
  (val) => !!val,
  'Esse campo é obrigatório',
);

export const requiredIf = (fn) => createValidation(
  (val) => !fn() || !!val,
  'Esse campo é obrigatório',
);

export const fieldMaxLength = (max) => createValidation(
  (val) => isLength(val, { max }),
  `O campo deve ter até ${max} caracteres`,
);

export const fieldMinLength = (min) => createValidation(
  (val) => isLength(val, { min }),
  `O campo deve ter pelo menos ${min} caracteres`,
);

export const fieldRangeLength = (min, max) => createValidation(
  (val) => isLength(val, { min, max }),
  `O campo deve ter entre ${min} e ${max} caracteres`,
);
